module.exports = __webpack_public_path__ + "img/message.65232161.svg";